{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Rozšírenie pre Chrome nie je nainštalované.",
      "CTA": "Nainštalovať rozšírenie"
    },
    "STATUS": {
      "OFFLINE": "Telefón odpojený",
      "IN_OTHER_TAB": "Telefón pripojený na inej karte",
      "CONNECTING": "Pripájam sa...",
      "DISCONNECTING": "Odpájam sa...",
      "ONLINE": "Telefón pripojený",
      "DIALING": "Vytáčam",
      "TRANSFERRING": "Prepájam...",
      "CONSULTING": "Hovor s kolegom",
      "CALLER_ON_HOLD": "Volajúci čaká na linke",
      "BUSY": "Obsadené",
      "DND": "DND",
      "UNAVAILABLE": "Nedostupný",
      "REJECTED": "Hovor odmietnutý",
      "CALL_FAILED": "Hovor zlyhal"
    },
    "QUEUES": {
      "MORE": "Ďalšie fronty"
    },
    "TABS": {
      "PHONE": "Telefón",
      "SMS": "SMS",
      "HISTORY": "História"
    },
    "HISTORY": {
      "OPEN": "Otvorené",
      "RECENT": "Nedávne",
      "MISSED": "Zmeškané",
      "LOADING": "Načítavam hovory...",
      "EMPTY": "Žiadne hovory",
      "ERROR": "Hovory sa nepodarilo načítať",
      "CALL": "Zavolať späť",
      "CALL_STATUS": {
        "BUTTON": "Nastaviť stav hovoru",
        "TITLE": "Stav hovoru",
        "SEARCH_PLACEHOLDER": "Hľadať stavy...",
        "LOADING": "Načítavam stavy...",
        "NO_OPTIONS": "Nie sú nastavené žiadne stavy hovoru",
        "NO_MATCH": "Žiadny stav nezodpovedá",
        "OPTIONS_ERROR": "Stavy sa nepodarilo načítať",
        "RETRY": "Skúsiť znova",
        "CONFIRM_QUESTION": "Nastaviť „{status}“ a vyriešiť konverzáciu?",
        "CONFIRM": "Potvrdiť",
        "BACK": "Späť",
        "CANCEL": "Zrušiť",
        "SAVING": "Ukladám...",
        "SAVE_ERROR": "Stav sa nepodarilo uložiť",
        "RESOLVE_ERROR": "Stav bol uložený, ale konverzáciu sa nepodarilo vyriešiť"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefónne číslo, napr. +421903000000",
      "BODY_PLACEHOLDER": "Napíšte správu...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Odoslať SMS",
      "SENDING": "Odosielam...",
      "SENT": "SMS odoslaná",
      "LOADING": "Načítavam SMS schránky...",
      "NO_INBOX": "Tento účet nemá SMS schránku, SMS nie je možné odoslať.",
      "INVALID_NUMBER": "Zadajte číslo v medzinárodnom formáte vrátane úvodného +.",
      "ERROR": "SMS sa nepodarilo odoslať. Skúste to prosím znova."
    },
    "ACTIONS": {
      "CONNECT": "Prihlásiť",
      "GO_TO_TAB": "Prejsť na kartu",
      "DISCONNECT": "Odhlásiť",
      "ANSWER": "Prijať",
      "HANGUP": "Zložiť",
      "HOLD": "Podržať",
      "MUTE": "Vypnúť mikrofón",
      "SILENCE": "Stíšiť",
      "TRANSFER": "Prepojiť",
      "COMPLETE_TRANSFER": "Dokončiť prepojenie",
      "RETURN_TO_CALLER": "Späť k volajúcemu",
      "CANCEL_TRANSFER": "Zrušiť prepojenie",
      "DIALPAD": "Zobraziť číselník",
      "OPEN_CONVERSATION": "Otvoriť konverzáciu"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Prichádzajúci hovor",
      "INCOMING_CALL_FROM": "Prichádzajúci hovor od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Prichádzajúci hovor od {number}",
      "ANSWER": "Prijať",
      "DECLINE": "Odmietnuť"
    },
    "TRANSFER": {
      "TITLE": "Prepojiť hovor",
      "PLACEHOLDER": "Zadajte číslo pre prepojenia...",
      "SEARCH_PLACEHOLDER": "Hľadať agenty...",
      "TARGET_PLACEHOLDER": "Vybraný cieľ prepojenia",
      "CONFIRM": "Prepojiť",
      "MODE_DIRECT": "Prepojiť rovno",
      "MODE_CONSULT": "Najprv zavolať kolegovi",
      "CANCEL": "Zrušiť"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Naozaj chcete ísť na pauzu pre všetky fronty?",
      "CONFIRM_READY": "Naozaj sa chcete vrátiť na status pripravený pre všetky fronty?",
      "CONFIRM_BREAK_QUEUE": "Naozaj sa chcete odhlásiť z fronty {queue}?",
      "CONFIRM_READY_QUEUE": "Naozaj sa chcete prihlásiť do fronty {queue}?",
      "LOGIN_TO_QUEUE": "Prihlásiť",
      "LOGOUT_FROM_QUEUE": "Odhlásiť",
      "LOGIN_TO_ALL_QUEUES": "Prihlásiť do všetkých front",
      "LOGOUT_FROM_ALL_QUEUES": "Odhlásiť zo všetkých front",
      "OPTION_LOGOUT": "Odhlásiť",
      "OPTION_BREAK": "Prestávka",
      "OPTION_LUNCH": "Obed",
      "OPTION_AWAY": "Neprítomný",
      "OPTION_DO_NOT_DISTURB": "Nerušiť",
      "OPTION_BUSINESS_TRIP": "Služobná cesta",
      "CONFIRM": "Potvrdiť",
      "CANCEL": "Zrušiť"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Telefón sa nepodarilo pripojiť",
      "MESSAGE": "Zdá sa, že vaše internetové pripojenie nefunguje. Skontrolujte ho, prosím, a skúste to znova.",
      "CREDENTIALS_TITLE": "PBX systém odmietol vaše prihlasovacie údaje",
      "CREDENTIALS_MESSAGE": "PBX systém odmietol používateľské meno alebo heslo uložené vo vašom profile. Skontrolujte ich v Nastaveniach profilu, alebo sa obráťte na svojho administrátora.",
      "CONFIGURATION_TITLE": "Nastavenia telefónu nie sú platné",
      "CONFIGURATION_MESSAGE": "SIP používateľské meno alebo adresa servera nemá platný formát, preto sa telefón nemôže pripojiť. Opravte to v Nastaveniach profilu.",
      "NETWORK_SHORT": "Pripojenie zlyhalo",
      "CREDENTIALS_SHORT": "Prihlasovacie údaje odmietnuté",
      "CONFIGURATION_SHORT": "Neplatné nastavenia telefónu",
      "RETRY": "Skúsiť znova",
      "DISMISS": "Zrušiť"
    },
    "CONNECTION_QUALITY": "Kvalita pripojenie",
    "CONNECTION_QUALITY_EXCELLENT": "Skvelá",
    "CONNECTION_QUALITY_GOOD": "Dobrá",
    "CONNECTION_QUALITY_FAIR": "Priemerná",
    "CONNECTION_QUALITY_POOR": "Zlá",
    "CONNECTION_QUALITY_DISCONNECTED": "Odpojené"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Vytáčam {number}… Môžete zavrieť túto záložku.",
    "NO_NUMBER": "Nebolo zadané číslo. Použite ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Zadajte telefónne číslo...",
    "ACTIONS": {
      "DIAL": "Vytočiť číslo",
      "DIAL_FROM": "Zvoliť číslo, z ktorého volám"
    },
    "DIAL_FROM": {
      "TITLE": "Volať z čísla schránky"
    },
    "VALIDATION": {
      "REQUIRED": "Telefónne číslo je povinné",
      "INVALID_FORMAT": "Neplatný formát telefónneho čísla"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Nastavenia a testovanie zvuku",
    "SELECT_DEVICE": "Vyberte zariadenie...",
    "SYSTEM_DEFAULT": "Systémové predvolené",
    "SAVED": "Uložené",
    "DISCONNECTED_SUFFIX": "nepripojené",
    "DEVICE_DISCONNECTED": "Vybrané zariadenie nie je pripojené. Hovory použijú systémové predvolené, kým sa nevráti.",
    "MICROPHONE": {
      "TITLE": "Mikrofón",
      "START_TEST": "Testovať mikrofón",
      "STOP_TEST": "Ukončiť test",
      "LEVEL": "Hlasitosť:",
      "VERDICT": {
        "LISTENING": "Povedzte niečo do mikrofónu…",
        "SILENT": "Nie je vás počuť. Skontrolujte, či je mikrofón zapnutý a vybraný ten správny.",
        "LOW": "Je vás počuť len potichu. Vyberte iný mikrofón alebo upravte vstupnú hlasitosť v nastaveniach systému.",
        "GOOD": "Dobrý zvuk — je vás dobre počuť."
      }
    },
    "SPEAKER": {
      "TITLE": "Reproduktor",
      "TEST": "Testovať reproduktor",
      "TESTING": "Testujem...",
      "VOLUME": "Hlasitosť:",
      "USING_DEFAULT": "Vybraný výstup nie je dostupný — prehrané cez systémové predvolené zariadenie."
    },
    "DONE": "Hotovo",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Chyba pri prístupu k mikrofónu. Skontrolujte oprávnenie.",
      "MICROPHONE_PERMISSION_DENIED": "Prístup k mikrofónu je blokovaný. Povoľte ho v nastaveniach lokality v prehliadači, aby ste mohli telefonovať.",
      "MICROPHONE_SILENT": "Váš mikrofón nezachytáva žiadny zvuk. Skontrolujte nastavenia zvuku.",
      "EXTENSION_REQUIRED": "Telefónne rozšírenie sa nenašlo. Nainštalujte alebo povoľte ho, aby ste mohli používať mikrofón.",
      "SPEAKER_TEST": "Chyba pri testovanie reproduktora."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Obsadené"
  },
  "QUEUE_STATUS": {
    "READY": "Pripravený",
    "NOT_READY": "Neprijíma hovory",
    "WRAP_UP": "Dokončuje hovor",
    "BREAK": "Pauza",
    "LUNCH": "Obed",
    "AWAY": "Neprítomný",
    "DO_NOT_DISTURB": "Nerušiť",
    "BUSINESS_TRIP": "Služobná cesta",
    "OTHER_CALL": "Iný hovor",
    "QUEUE_CALL": "Hovor z fronty",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Bez telefónu",
    "PARTIALLY_READY": "Čiastočne pripravený",
    "MIXED": "Zmiešaný",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Zaneprázdnený (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
